/*---------------------------------------------------------*\
 * WeatherIconsController
\*---------------------------------------------------------*/
class WeatherIconsController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor(weatherService, $timeout) {
    this.$timeout = $timeout;
    this.name = 'weatherIconsComponent';
    this.$timeout(() => {
      this.regionId = (this.region && this.region.abbr) || 'LI';
      this.iconsSrc = weatherService.getWeatherIconsUrl(this.regionId);
    });
  }
}

WeatherIconsController.$inject = [
  'weatherService',
  '$timeout'
];

export default WeatherIconsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/weatherIcons/weatherIcons.controller.js
 **/